import { useContext } from 'react';
import { PartyContext } from '../contexts/PartyContext';

export const useParty = () => {
  const context = useContext(PartyContext);

  if (!context) {
    throw new Error('useParty must be used within a PartyContextProvider');
  }

  return context;
}; 